import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../Demoseal.png';
import { decodeToken } from '../utils/auth';

const platformHighlights = [
  'Applications',
  'AI-assisted review',
  'Programs and policy',
  'Decisions and audit trail',
];

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    const payload = decodeToken(token);
    if (payload && (!payload.exp || payload.exp * 1000 > Date.now())) {
      navigate('/dashboard', { replace: true });
    }
  }, [navigate]);

  return (
    <div className="landing-site">
      <header className="landing-topbar">
        <button type="button" className="landing-wordmark" onClick={() => navigate('/')}>
          <img src={logo} alt="NuGrants" className="landing-wordmark-logo" />
          <span>NuGrants</span>
        </button>
        <div className="landing-topbar-actions">
          <button
            type="button"
            className="landing-btn landing-btn-secondary"
            onClick={() => navigate('/signin')}
          >
            Sign In
          </button>
        </div>
      </header>

      <main className="landing-main">
        <section className="landing-hero-band">
          <div className="landing-hero-content">
            <div className="landing-hero-copy">
              <p className="landing-hero-kicker">Internal grant intake and review operations</p>
              <h1 className="landing-hero-title">
                One workspace for grant applications, review, and decisions.
              </h1>
              <p className="landing-hero-subtitle">
                Move applications from intake to prescreening, review, attachments, and
                final decisions inside one organized internal workspace for grant teams.
              </p>
              <div className="landing-chip-row">
                {platformHighlights.map((item) => (
                  <span key={item} className="landing-chip">
                    {item}
                  </span>
                ))}
              </div>
              <div className="landing-hero-actions">
                <button
                  type="button"
                  className="landing-btn landing-btn-primary"
                  onClick={() => navigate('/signin')}
                >
                  Open Workspace
                </button>
                <button
                  type="button"
                  className="landing-btn landing-btn-secondary"
                  onClick={() => navigate('/signin')}
                >
                  Sign In
                </button>
              </div>
              <div className="landing-hero-meta">
                <div className="landing-hero-stat">
                  <strong>One workspace</strong>
                  <span>Applications, AI review, compliance, and decisions connected together.</span>
                </div>
                <div className="landing-hero-stat">
                  <strong>Reviewer focused</strong>
                  <span>Built for internal staff workflows rather than public applicant intake alone.</span>
                </div>
              </div>
            </div>
            <div className="landing-hero-visual">
              <div className="landing-preview-window">
                <div className="landing-preview-toolbar">
                  <span />
                  <span />
                  <span />
                </div>
                <div className="landing-product-mockup" aria-label="NuGrants workspace preview">
                  <aside className="landing-mockup-sidebar">
                    <div className="landing-mockup-seal">
                      <img src={logo} alt="" />
                    </div>
                    <div className="landing-mockup-nav">
                      <span className="active">Funding</span>
                      <span>Applications</span>
                      <span>Programs</span>
                      <span>Review</span>
                    </div>
                  </aside>
                  <div className="landing-mockup-main">
                    <div className="landing-mockup-topbar">
                      <span className="landing-mockup-search" />
                      <span className="landing-mockup-user" />
                    </div>
                    <div className="landing-mockup-hero">
                      <div className="landing-mockup-kicker" />
                      <div className="landing-mockup-title" />
                      <div className="landing-mockup-title short" />
                      <div className="landing-mockup-copy" />
                    </div>
                    <div className="landing-mockup-stats">
                      <div />
                      <div />
                      <div />
                    </div>
                    <div className="landing-mockup-table">
                      <div className="landing-mockup-table-row header">
                        <span />
                        <span />
                        <span />
                        <span />
                      </div>
                      <div className="landing-mockup-table-row">
                        <span />
                        <span />
                        <span />
                        <span className="badge" />
                      </div>
                      <div className="landing-mockup-table-row">
                        <span />
                        <span />
                        <span />
                        <span className="badge blue" />
                      </div>
                      <div className="landing-mockup-table-row">
                        <span />
                        <span />
                        <span />
                        <span className="badge green" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Home;
